import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { COUNTRY } from '../../interfaces/country.interface';
import { LOGIN_MODE } from '../../interfaces/login-mode.interface';
import { ConstantsService } from '../constants/constants.service';
declare let bootstrap: any;

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    window = window;
    loginModes: LOGIN_MODE[] = [];
    listOfCountries: COUNTRY[] = [];
    constructor(
    private constantsService: ConstantsService
    ) { }

    getCrudButtonTooltipTitle(title: string) {
        if(window?.innerWidth <= 768) return title;
        return '';
    }
    async getLoginModes() {
        if(!this.loginModes?.length)
            try {
                const tempData = await firstValueFrom(this.constantsService?.getLoginModes());
                this.loginModes = [];
                tempData?.forEach((mode)=> {
                    this.loginModes?.push({
                        key: mode === 'oauth2' ? 'Via Google/Microsoft Account' : ( mode === 'basic' ? 'Via Username and Password' : 'Via API Integration'),
                        value: mode
                    });
                });
                return this.loginModes;
            }
            catch (error) {
                console.error(error);
                this.loginModes = [];
                return this.loginModes;
            }

        return this.loginModes;
    }

    async getListOfCountries() {
        if(!this.listOfCountries?.length)
            try {
                this.listOfCountries = await firstValueFrom(this.constantsService?.getListOfCountries());
                return this.listOfCountries;
            }
            catch (error) {
                console.error(error);
                this.listOfCountries = [];
                return this.listOfCountries;
            }
        return this.listOfCountries;
    }

    filterData(arr: any, columnToCompare: any, valueToBeCompared: any): any {
        return arr?.find(obj => obj?.[columnToCompare] == valueToBeCompared);
    }

    initPopover(selector: string): void {
        const list = [].slice.call(
            document.querySelectorAll(`${selector} [data-bs-toggle="popover"]`)
        );
        list.map((el) => {
            const opts = {
                animation: false,
                sanitize: false,
            };
            if (el.hasAttribute('data-bs-content-id')) {
                opts['content'] = document.getElementById(
                    el.getAttribute('data-bs-content-id') as string
                ).innerHTML;
                opts['html'] = true;
            }

            const _popover = new bootstrap.Popover(el, opts);
            _popover.hide();
            el.addEventListener('shown.bs.popover', () => {
                const elem = document.querySelector('.bs-popover-auto.show');
                if(!elem) return;
                elem.setAttribute('tabIndex', '-1');
                const closeButton = elem.querySelector('.popover-close');
                if(!closeButton) return;

                closeButton.addEventListener('click', () => {
                    _popover.hide();
                });
            });

            window.addEventListener('popstate', () => {
                _popover.hide();
            });

            return _popover;
        });

        document.addEventListener('click', (e)=> {
            const popoverInstances = document.querySelectorAll('.bs-popover-auto.show');
            popoverInstances?.forEach((instance) => {
                const triggerElem = document.querySelector(`[aria-describedby='${instance.getAttribute('id')}']`);
                const triggeredInstance = bootstrap.Popover.getInstance(triggerElem);
                if(triggerElem && !instance.contains(e.target as Node)) triggeredInstance.hide();
            });
        });
    }
}
